@use 'kci-design-lib/styles/variables.scss' as *;
.custom-datepicker {
  width: auto;
  height: 48px;
  max-width: 100%;
  position: relative;
  &.disabled {
    [data-pc-name='inputtext'] {
      color: $pbl-text-dsbl;
      border: 1px solid $sbl-brdr-dsbl;
      &::placeholder {
        color: $pbl-text-dsbl;
      }
    }
    button {
      svg {
        path {
          fill: $pbl-text-dsbl;
        }
      }
      img {
        filter: brightness(0) saturate(100%) invert(38%) sepia(0%) saturate(3112%) hue-rotate(105deg) brightness(104%) contrast(84%);
      }
    }
  }
  button {
    background-color: transparent;
    border: none;
    color: $sbl-text;
    height: 48px;
    position: absolute;
    right: 0px;
    box-shadow: none;
    text-decoration: none;
    &:hover {
      text-decoration: none;
      border: none;
      box-shadow: none;
    }
    svg {
      path {
        fill: $sbl-text;
      }
    }
    &:hover img {
      filter: var(--filter-icon-accent);
    }
  }
  [data-pc-name='inputtext'] {
    width: 352px;
    border-radius: 4px;
    padding: 12px 16px;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    line-height: 24px;
    font-weight: 400;
    color: var(--main-text);
    background-color: var(--datepicker-input-bg);
    border: 1px solid var(--border-elevated);
    &::placeholder {
      color: $default-neutral;
    }
    &:focus {
      outline: none;
      box-shadow: none;
      border-radius: 0px;
    }
    &[aria-expanded='true'] {
      box-shadow: none;
      border: 1px solid var(--prime-btn-brdr);
    }
  }
  &.active,
  &.selected {
    [data-pc-name='inputtext'] {
      border-color: var(--prime-btn-brdr);
    }
  }
}
:global {
  .p-datepicker[data-pc-section='panel'] {
    width: 352px;
    border-radius: 4px;
    border: 1px solid var(--datepicker-panel-nav-border);
    background-color: var(--datepicker-panel-bg);
    font-family: $font-family;
    [data-pc-section='group'],
    [data-pc-section='header'],
    [data-pc-section='calendarcontainer'],
    [data-pc-section='tableheader'],
    [data-pc-section='tablebody'] {
      background-color: var(--datepicker-panel-bg);
    }
    .p-datepicker-group,
    .p-datepicker-header,
    .p-datepicker-calendar-container,
    .p-datepicker-calendar,
    .p-datepicker-weekday-cell,
    .p-datepicker-day-cell {
      background-color: var(--datepicker-panel-bg);
    }
    td {
      padding: 0px;
    }
    [data-p-highlight='true'] {
      background-color: var(--datepicker-panel-selected-bg);
      color: var(--datepicker-panel-selected-text);
    }
    &:not([data-p-disabled='true']) {
      td {
        span {
          &:not([data-p-highlight='true']) {
            &:not([data-p-disabled='true']) {
              &:hover {
                padding: 0px;
              }
            }
          }
        }
      }
    }
    button {
      font-family: $font-family;
    }
  }
}
.datepicker-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
  text-align: left;
  font-size: 16px;
  color: var(--checkbox-radio-text);
  &:has(+ .custom-datepicker.disabled) {
    color: $pbl-text-dsbl;
  }
  span {
    &:has(+ .custom-datepicker.disabled) {
      color: $pbl-text-dsbl;
    }
  }
}
:global {
  .p-datepicker [data-pc-section='table'] {
    margin: 0;
    tr {
      height: 48px;
    }
    th {
      padding: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: $active-grey;
      span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        box-sizing: border-box;
        padding: 14px 9px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: $active-grey;
      }
    }
    td {
      padding: 0;
      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: var(--datepicker-panel-day-text);
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        box-sizing: border-box;
        &[data-p-disabled='true'] {
          color: $pbl-text-dsbl;
          opacity: unset;
        }
      }
    }
  }
  .p-datepicker [data-pc-section='previousbutton'],
  .p-datepicker [data-pc-section='nextbutton'] {
    background-color: var(--datepicker-panel-nav-bg);
    width: 24px;
    height: 24px;
    border: 1px solid var(--datepicker-panel-nav-border);
    border-radius: 50%;
    svg {
      width: 10px;
      height: 10px;
      justify-content: center;
      display: grid;
      place-items: center;
      color: var(--datepicker-panel-nav-icon);
    }
  }
  .p-datepicker [data-pc-section='group'] {
    [data-pc-section='header'] {
      height: 48px;
      border: none;
      background-color: var(--datepicker-panel-bg);
    }
  }
  .p-datepicker [data-pc-section='title'] {
    button {
      font-size: 16px;
      font-weight: 700;
      line-height: 160%;
      color: var(--datepicker-panel-title-text);
    }
    [data-pc-section='monthtitle'] {
      margin: 0;
      padding-right: 4px;
      border: none;
    }
    [data-pc-section='yeartitle'] {
      padding-left: 4px;
      border: none;
    }
  }
  .p-datepicker [data-pc-section='daylabel'] {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .p-datepicker[data-pc-section="panel"] {
    &:has([data-p-today]) {
      [data-p-highlight='true'] {
        >span,
        span {
          background-color: var(--datepicker-panel-selected-bg);
          color: var(--datepicker-panel-selected-text);
          border-radius: 50%;
        }
      }
    }
  }
  .p-datepicker [data-p-range-start='true'],
  .p-datepicker [data-p-range-end='true'],
  .p-datepicker [data-p-in-range='true'] {
    position: relative;
  }
  .p-datepicker td[data-p-in-range='true'] {
    background-color: var(--datepicker-panel-selected-bg);
    >span {
      background-color: var(--datepicker-panel-selected-bg);
      color: var(--datepicker-panel-selected-text);
      border-radius: 0;
    }
  }
  .p-datepicker td[data-p-range-start='true'] {
    background: linear-gradient(to right, transparent 50%, var(--datepicker-panel-selected-bg) 50%);
    >span {
      background-color: var(--datepicker-panel-selected-bg);
      color: var(--datepicker-panel-selected-text);
      border-radius: 50%;
      position: relative;
      z-index: 1;
    }
  }
  .p-datepicker td[data-p-range-end='true'] {
    background: linear-gradient(to left, transparent 50%, var(--datepicker-panel-selected-bg) 50%);
    >span {
      background-color: var(--datepicker-panel-selected-bg);
      color: var(--datepicker-panel-selected-text);
      border-radius: 50%;
      position: relative;
      z-index: 1;
    }
  }
  .p-datepicker td[data-p-today='true'] {
    background: transparent;
    >span {
      background-color: transparent;
      border: 1px solid var(--datepicker-panel-today-border);
      color: var(--datepicker-panel-today-text);
      border-radius: 50%;
      position: relative;
      z-index: 2;
    }
  }
  .p-datepicker td[data-p-today='true'][data-p-range-start='true'] {
    background: linear-gradient(to right, transparent 50%, var(--datepicker-panel-selected-bg) 50%);
    >span {
      background-color: transparent;
      border: 1px solid var(--datepicker-panel-today-border);
      color: var(--datepicker-panel-today-text);
      border-radius: 50%;
      position: relative;
      z-index: 2;
    }
  }
  .p-datepicker td[data-p-today='true'][data-p-range-end='true'] {
    background: linear-gradient(to left, transparent 50%, var(--datepicker-panel-selected-bg) 50%);
    >span {
      background-color: transparent;
      border: 1px solid var(--datepicker-panel-today-border);
      color: var(--datepicker-panel-today-text);
      border-radius: 50%;
      position: relative;
      z-index: 2;
    }
  }
  .p-datepicker td[data-p-today='true'][data-p-in-range='true'] {
    background-color: var(--datepicker-panel-selected-bg);
    >span {
      background-color: transparent;
      border: 1px solid var(--datepicker-panel-today-border);
      color: var(--datepicker-panel-today-text);
      border-radius: 50%;
      position: relative;
      z-index: 2;
    }
  }
  .p-datepicker [data-pc-section='day'] {
    span {
      &:not([data-p-highlight='true']) {
        &:hover {
          color: var(--datepicker-panel-day-hover-text);
          background: none;
        }
      }
    }
  }
}
.mandatory {
  color: $mandatory-text;
}
.custom-datepicker {
  [data-pc-name='inputtext'] {
    background-color: var(--datepicker-input-bg);
    color: var(--datepicker-input-text);
    &::placeholder {
      color: var(--datepicker-placeholder-color, var(--datepicker-input-text));
    }
  }
  svg {
    path {
      fill: var(--datepicker-input-text);
    }
  }
  img {
    filter: var(--datepicker-icon-filter);
  }
}
[data-theme='dark'] {
  .custom-datepicker {
    button img {
      filter: brightness(0) saturate(100%) invert(100%) sepia(47%) saturate(3318%) hue-rotate(175deg) brightness(109%) contrast(101%);
    }
    button:hover img {
      filter: brightness(0) saturate(100%) invert(80%) sepia(40%) saturate(431%) hue-rotate(170deg) brightness(103%) contrast(101%);
    }
  }
}
